import { radiansToDegrees } from '@turf/turf';
import React from 'react';

import { Attitude as AttitudeUI } from '@/components/ui/dashboard/Monitor';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const Attitude = ({ data: robotId, className }) => {
  const attitude = useRobotTelemetry(robotId, MESSAGE.ATTITUDE);

  return (
    <AttitudeUI
      roll={attitude ? radiansToDegrees(attitude.roll) : 0}
      pitch={attitude ? radiansToDegrees(attitude.pitch) : 0}
      yaw={attitude ? radiansToDegrees(attitude.yaw) : 0}
      className={className}
    />
  );
};

export default Attitude;
